"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var selectors_1 = require("../../selectors");
var utils_1 = require("../../utils");
var MissedOpportunitiesGraph_1 = __importDefault(require("./MissedOpportunitiesGraph"));
var MissedOpportunities = function (_a) {
    var headerLevel = _a.headerLevel, limit = _a.limit, showOthers = _a.showOthers;
    var serviceStats = (0, react_redux_1.useSelector)(selectors_1.selectSlightlyPopulatedServiceStatsWithToolAnalysis);
    var _b = __read(react_1.default.useMemo(function () { return (0, react_redux_firebase_1.isLoaded)(serviceStats) ? (0, utils_1.getTopNAndOthers)(serviceStats, 'missedOpportunityAmount', limit) : []; }, [serviceStats, limit]), 2), topN = _b[0], others = _b[1];
    if (!(0, react_redux_firebase_1.isLoaded)(serviceStats)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ p: 2 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: headerLevel }, { children: "Missed Opportunities" })), topN === null || topN === void 0 ? void 0 : topN.map(function (sStat) {
                var _a, _b;
                return ((0, jsx_runtime_1.jsx)(MissedOpportunitiesGraph_1.default, { service: sStat.service, spend: (_a = sStat.toolAnalysis) === null || _a === void 0 ? void 0 : _a.last12MonthSpend, amount: ((_b = sStat.toolAnalysis) === null || _b === void 0 ? void 0 : _b.missedOpportunityAmount) || 0 }, sStat.id));
            }), showOthers && others && ((0, jsx_runtime_1.jsx)(MissedOpportunitiesGraph_1.default, { label: "+ ".concat(others.count, " more..."), spend: others.spend, amount: others.amount }))] })));
};
exports.default = MissedOpportunities;
